import { ToasterProps } from "sonner";

export const toasterConfig: ToasterProps = {
    duration: 3500, // Общая длительность показа сообщений (в миллисекундах)
    position: "top-center", // Расположение сообщений (одно из допустимых значений)
    className: "toastWindow", // Кастомный класс для стилизации
  };